'use client'

import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

export default function HomeTestimonialSection() {
    return (
        <section className=" theme-pt-40 theme-pb-40 theme-pl-30 theme-pr-30">
            <div className="auto-container">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 theme-mb-30">
                        <div className="site-heading text-left">
                            <h2>DEPOIMENTOS</h2>
                            <p>A confiança de quem já fez negócio conosco</p>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mr-auto ml-auto">
                        <Swiper
                            id='testimonial'
                            modules={[Navigation]}
                            autoplay={false}
                            spaceBetween={30}
                            loop={true}
                        >
                            <div className='swiper-wrapper'>
                                <SwiperSlide className='testimonial-item'>
                                    <div className="tcontent">
                                        <blockquote>
                                            <p>Experiência incrível. Atendimento excelente durante a compra, e principalmente no pós venda. Dificilmente você irá achar uma loja que te da todo suporte no pós venda, diferente da Club Car.</p>
                                            <div className="testimonial-author">
                                            <p><strong className="font-weight-extra-bold">Gustavo Zaniti</strong></p>
                                            </div>
                                        </blockquote>
                                        <div className="testimonial-arrow-down"></div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className='testimonial-item'>
                                    <div className="tcontent">
                                        <blockquote>
                                            <p>Ótima empresa, bom atendimento pessoal honesto e transparente, Moro em MG comprei um veículo deles e fiquei muito satisfeito do início ao fim da negociação, indico sim!</p>
                                            <div className="testimonial-author">
                                            <p><strong className="font-weight-extra-bold">Paulo Sérgio</strong></p>
                                            </div>
                                        </blockquote>
                                        <div className="testimonial-arrow-down"></div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className='testimonial-item'>
                                    <div className="tcontent">
                                        <blockquote>
                                            <p>Excelentes no que faz, sempre quando preciso trocar meus carros nem perco tempo com outros. Indico sem medo de errar.</p>
                                            <div className="testimonial-author">
                                            <p><strong className="font-weight-extra-bold">Arruda Silva</strong></p>
                                            </div>
                                        </blockquote>
                                        <div className="testimonial-arrow-down"></div>
                                    </div>
                                </SwiperSlide>
                            </div>
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
}